import type { Theme } from '@mui/material';
import type { Components } from '@mui/material/styles';

export default function MuiDialog(theme: Theme): Components['MuiDialog'] {
  return {
    defaultProps: {
      fullWidth: true,
      maxWidth: 'lg',
    },
    styleOverrides: {
      paper: {
        margin: theme.spacing(2),
        boxShadow: theme.shadows[24],
        borderRadius: theme.shape.borderRadiusXLarge,
      },
      paperFullWidth: {
        width: '100%',
      },
      paperFullScreen: {
        borderRadius: 0,
      },
    },
  };
}
